import React from 'react'
import { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CardContext from '../context/CardContext';

export default function CardEdit({ img, link, title, text, index, handleFinishedEdit }) {
    const [cardContent, setCardContent] = useState( { img, link, title, text, index } )

    const { updateCard } = useContext(CardContext)

    const handleUpdate = () => { 
        updateCard(cardContent)
        handleFinishedEdit()
    }

    return (
        <div className="card-edit-wrapper">
            <label className="card-input-group">
                <FontAwesomeIcon icon="image" /><input value={cardContent.img} type="text" onChange={ (e) => { setCardContent({ ...cardContent, img : e.target.value }) }} />  
            </label>
            
            <label className="card-input-group"><FontAwesomeIcon icon="link" /><input value={cardContent.link} type="text" onChange={ (e) => { setCardContent({ ...cardContent, link : e.target.value }) }} /></label>
            <label className="card-input-group"><FontAwesomeIcon icon="heading" /><input value={cardContent.title} type="text" onChange={ (e) => { setCardContent({ ...cardContent, title : e.target.value }) }} /></label>
            <label className="card-input-group"><FontAwesomeIcon icon="paragraph" /><input value={cardContent.text} type="text" onChange={ (e) => { setCardContent({ ...cardContent, text : e.target.value }) }} /></label>
            
            <button className="card-edit-update" onClick={ () => { handleUpdate() }}><FontAwesomeIcon icon="check" inverse /></button>
        </div>
    )
}
